// src/components/Actions.js
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLungs, faMedkit, faSyringe } from '@fortawesome/free-solid-svg-icons';

const Actions = ({ addTimelineEvent }) => {
    const handleAcknowledgeEpinephrine = () => {
        addTimelineEvent("Epinephrine Administered");
    };

    const handleAcknowledgeIOAccess = () => {
        addTimelineEvent("IO Access Established");
    };

    const handleAcknowledgeIVAccess = () => {
        addTimelineEvent("IV Access Established")
    };

    const handleAcknowledgeIntubation = () => {
        addTimelineEvent("Patient Intubated")
    };
    
    const handleAcknowledgeAmio = () => {
        addTimelineEvent("Amiodarone Administered")
    };

    const handleAcknowledgeLidocane = () => {
        addTimelineEvent("Lidocane Administered")
    };


    return (
        <div className="actions">
            <h2>Actions</h2>
            <button className="btn" onClick={handleAcknowledgeEpinephrine}>
                <FontAwesomeIcon icon={faSyringe} /> Epinephrine
            </button>
            <button className="btn" onClick={handleAcknowledgeIOAccess}>
                <FontAwesomeIcon icon={faMedkit} /> IO Access
            </button>
            <button className="btn" onClick={handleAcknowledgeIVAccess}>
            <FontAwesomeIcon icon={faMedkit} /> IV Access
        </button>
            <button className="btn" onClick={handleAcknowledgeIntubation}>
            <FontAwesomeIcon icon={faLungs} /> Intubation
            </button>
            <button className="btn" onClick={handleAcknowledgeAmio}>
                <FontAwesomeIcon icon={faSyringe} /> Amiodarone
            </button>
            <button className="btn" onClick={handleAcknowledgeLidocane}>
                <FontAwesomeIcon icon={faSyringe} /> Lidocane
            </button>
        </div>
    );
};

export default Actions;
